module.exports = __webpack_public_path__ + "img/shape_rectangle--yellow.5639cae.png";